import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { BrandWrapper } from 'src/modules/onboarding/components/BrandWrapper';

import { SetOfAssessments } from '../components/SetOfAssessments';
import { FlowType } from '../models/assessments';

type Props = RouteComponentProps<
    {},
    {},
    {
        sessionUuid?: string;
    }
>;

const InnerWrapper = styled.div({
    display: 'flex',
    alignItems: 'center',
    flex: 1,
});

export enum PreSessionAssessmentsPageTestID {
    Wrapper = 'PreSessionAssessmentsPageTestID.Wrapper',
}

export const PreSessionAssessmentsPage: React.FC<Props> = ({ location, history }) => {
    const sessionUuid = location?.state?.sessionUuid;

    useEffect(() => {
        if (!sessionUuid) {
            history.replace('/');
        }
    }, [sessionUuid]);

    const handleSubmit = () => {
        history.push('pre-session-assessments-score');
    };

    return sessionUuid ? (
        <BrandWrapper>
            <InnerWrapper data-testid={PreSessionAssessmentsPageTestID.Wrapper}>
                <SetOfAssessments
                    onSubmit={handleSubmit}
                    flowType={FlowType.PRE_SESSION}
                    startAssessmentFlowVariables={{ associatedVisitUuid: sessionUuid }}
                />
            </InnerWrapper>
        </BrandWrapper>
    ) : null;
};
